module.exports = __webpack_public_path__ + "static/img/txt_1.69fea9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/txt_1.png
// module id = a0aC
// module chunks = 1